import {ObjectModelActionType} from "../../enums/objectModelActionType";
import assertNever from "../../../global/assetNever";

export default class ObjectModelActionDefinition {
  static getComponent(actionType: ObjectModelActionType) {
    switch (actionType) {
      case ObjectModelActionType.DefaultAction:
        return 'default-action';
      case ObjectModelActionType.FillForm:
        return 'fill-form';
      case ObjectModelActionType.ChangeFieldValues:
        return 'change-field-values';
      case ObjectModelActionType.CustomNotification:
        return 'custom-notification';
      case ObjectModelActionType.ViewDocument:
        return 'view-document';
      case ObjectModelActionType.RunProcess:
        return 'run-process';
      case ObjectModelActionType.LinkToAccount:
        return 'link-to-account';
      default:
        assertNever(actionType);
    }
  }

  static getDisplayName(actionType: ObjectModelActionType) {
    switch (actionType) {
      case ObjectModelActionType.DefaultAction:
        return 'Default Action';
      case ObjectModelActionType.FillForm:
        return 'Fill a Form';
      case ObjectModelActionType.ChangeFieldValues:
        return 'Change Property Value';
      case ObjectModelActionType.CustomNotification:
        return 'Custom Notification';
      case ObjectModelActionType.ViewDocument:
        return 'View Document';
      case ObjectModelActionType.RunProcess:
        return 'Run a Process';
      case ObjectModelActionType.LinkToAccount:
        return 'Link to Account';
      default:
        assertNever(actionType);
    }
  }

  static getIcon(actionType: ObjectModelActionType) {
    switch (actionType) {
      case ObjectModelActionType.DefaultAction:
        return 'actions';
      case ObjectModelActionType.FillForm:
        return 'fill-form';
      case ObjectModelActionType.ChangeFieldValues:
        return 'change-field-values';
      case ObjectModelActionType.CustomNotification:
        return 'email';
      case ObjectModelActionType.ViewDocument:
        return 'fill-form'; // update when new icon is available
      case ObjectModelActionType.RunProcess:
        return 'process-flow';
      case ObjectModelActionType.LinkToAccount:
        return 'account-assign';
      default:
        assertNever(actionType);
    }
  }

  static getComponentClass(actionType: ObjectModelActionType) {
    return `builder-element element-${ObjectModelActionDefinition.getComponent(actionType)} oma-${ObjectModelActionDefinition.getComponent(actionType)}`;
  }

  static getControlGroups(): { name: string, icon: string, type: ObjectModelActionType }[] {
    return [
      {
        name: ObjectModelActionDefinition.getDisplayName(ObjectModelActionType.FillForm),
        icon: ObjectModelActionDefinition.getIcon(ObjectModelActionType.FillForm),
        type: ObjectModelActionType.FillForm
      },
      {
        name: ObjectModelActionDefinition.getDisplayName(ObjectModelActionType.ChangeFieldValues),
        icon: ObjectModelActionDefinition.getIcon(ObjectModelActionType.ChangeFieldValues),
        type: ObjectModelActionType.ChangeFieldValues
      },
      {
        name: ObjectModelActionDefinition.getDisplayName(ObjectModelActionType.CustomNotification),
        icon: ObjectModelActionDefinition.getIcon(ObjectModelActionType.CustomNotification),
        type: ObjectModelActionType.CustomNotification
      },
      {
        name: ObjectModelActionDefinition.getDisplayName(ObjectModelActionType.ViewDocument),
        icon: ObjectModelActionDefinition.getIcon(ObjectModelActionType.ViewDocument),
        type: ObjectModelActionType.ViewDocument
      },
      {
        name: ObjectModelActionDefinition.getDisplayName(ObjectModelActionType.RunProcess),
        icon: ObjectModelActionDefinition.getIcon(ObjectModelActionType.RunProcess),
        type: ObjectModelActionType.RunProcess
      },
      {
        name: ObjectModelActionDefinition.getDisplayName(ObjectModelActionType.LinkToAccount),
        icon: ObjectModelActionDefinition.getIcon(ObjectModelActionType.LinkToAccount),
        type: ObjectModelActionType.LinkToAccount
      },
    ];
  }
}